<template>
  <div>
    <div>
      <b-modal
        id="modalInfo"
        v-model="isModalOpened"
        modal-class="modalInfo"
        :title="title"
        @hidden="isOpen = false"
      >
        <b-container v-if="!success">
          <b-row v-if="clone" style="margin: 0 0 33px 0">
            <b-col
              >{{ $t("label_evaluation_administrator_model_clone_warning") }}
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form @submit.prevent="">
                <b-form-group label-class="text-sm-left">
                  <template slot="label">
                    <!--title-->
                    {{ $t("label_evaluation_administrator_model_name") }}
                  </template>
                  <b-form-input
                    id="label_evaluation_administrator_model_name"
                    v-model="model.evaluation_administrator_model_name"
                    type="text"
                    required
                  />
                </b-form-group>
                <form-error
                  :errors="errors['evaluation_administrator_model_name']"
                  :field-name="'evaluation_administrator_model_name'"
                />
                <b-form-group label-class="text-sm-left">
                  <template slot="label">
                    <!--title-->
                    {{ $t("label_evaluation_administrator_model_shortName") }}
                  </template>
                  <b-form-input
                    id="label_evaluation_administrator_model_shortName"
                    v-model="model.evaluation_administrator_model_shortName"
                    type="text"
                    required
                  />
                </b-form-group>
                <form-error
                  :errors="errors['evaluation_administrator_model_shortName']"
                  :field-name="'evaluation_administrator_model_shortName'"
                />
                <b-form-group label-class="text-sm-left">
                  <template slot="label">
                    <!--title-->
                    {{ $t("label_evaluation_administrator_model_version") }}
                  </template>
                  <b-form-input
                    id="label_evaluation_administrator_model_version"
                    v-model="model.evaluation_administrator_model_version"
                    type="text"
                    required
                  />
                </b-form-group>
                <form-error
                  :errors="errors['evaluation_administrator_model_version']"
                  :field-name="'evaluation_administrator_model_version'"
                />
                <b-row>
                  <b-col>
                    <div class="label">
                      {{ $t("label_evaluation_administrator_sealPercentages") }}
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="4">
                    <b-form-group
                      label-class="text-sm-left"
                      class="percentageEvaluation"
                    >
                      <template slot="label">
                        <!--title-->
                        {{ $t("label_evaluation_bronze") }}
                      </template>
                      <b-form-input
                        id="label_evaluation_bronze"
                        v-model="model.evaluation_bronze"
                        type="text"
                        required
                        style="text-align: center"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="4">
                    <b-form-group
                      label-class="text-sm-left"
                      class="percentageEvaluation"
                    >
                      <template slot="label">
                        <!--title-->
                        {{ $t("label_evaluation_silver") }}
                      </template>
                      <b-form-input
                        id="label_evaluation_silver"
                        v-model="model.evaluation_silver"
                        type="text"
                        required
                        style="text-align: center"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="4">
                    <b-form-group
                      label-class="text-sm-left"
                      class="percentageEvaluation"
                    >
                      <template slot="label">
                        <!--title-->
                        {{ $t("label_evaluation_gold") }}
                      </template>
                      <b-form-input
                        id="label_evaluation_gold"
                        v-model="model.evaluation_gold"
                        type="text"
                        required
                        style="text-align: center"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-form>
            </b-col>
          </b-row>
        </b-container>
        <div v-if="success && clone">
          {{ $t("label_evaluation_administrator_model_clone_success") }}
        </div>
        <div v-if="success && !clone">
          {{ $t("label_evaluation_administrator_model_save_success") }}
        </div>
        <div
          v-if="success"
          slot="modal-footer"
          class="w-100"
          style="text-align: right"
        >
          <b-btn variant="primary" @click="isOpen = false"> OK </b-btn>
        </div>
        <div v-if="!success" slot="modal-footer" class="w-100" style="text-align: right">
          <b-btn variant="primary" @click="saveEvaluation()">
            <slot name="action" />
          </b-btn>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>

import { axiosCall } from "../../../../utils/axiosCall";
import FormError from "../../../template/_template-error";
import { validateField } from "../../../../utils/commons";

export default {
  name: "EvaluationModelModal",
  components:{
    FormError,
  },
  data() {
    return {
        errors: {},
        checked: false,
        model: {
            evaluation_administrator_model_name: "",
            evaluation_administrator_model_shortName: "",
            evaluation_administrator_model_version: "",
            evaluation_bronze: "60",
            evaluation_silver: "70",
            evaluation_gold: "80",
        },
        success: false,
              validations: {
        // eslint-disable-next-line camelcase
        evaluation_administrator_model_name: ["required"],
      },

    }
  },
  props: {
    title:{
        type: String,
        default:""
    },
    id:{
        type: String,
        default: ""
    },
    clone:{
        type: Boolean,
        default: false
    },
    isModalOpened: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isOpen: {
      get: function () {
        return this.isModalOpened;
      },
      set: function (newValue) {
        this.$emit("update:isModalOpened", newValue);
      },
    },
  },

  watch: {
    model: {
      handler() {
        if (this.checked) {
          this.validateForm();
        }
      },
      deep: true,
    },
  },
  created(){
    if(this.id != null)
        this.loadModel()
  },
  methods: {
    validateForm() {
      this.checked = true;
      this.errors = { ...{} };
      var keys = Object.keys(this.model);
      for (var i = 0; i < keys.length; i++) {
        validateField(
          keys[i],
          this.model[keys[i]],
          this.validations[keys[i]],
          this.errors
        );
      }
      var errors = Object.keys(this.errors)
        .filter((s) => this.errors[s])
        .filter((r) => this.errors[r].length > 0);
      return errors.length === 0;
    },
    async loadModel() {
        this.$emit('update:loading', true)
        await axiosCall({ url: "EvaluationModels/" + this.id, method: "GET" }).then(
            (response) => {
            const prefix = this.clone ? "Copy of " : "";
            // eslint-disable-next-line camelcase
            this.model.evaluation_administrator_model_name =
                prefix + response.data.evaluation_administrator_model_name;
            // eslint-disable-next-line camelcase
            this.model.evaluation_administrator_model_shortName =
                prefix + response.data.evaluation_administrator_model_shortName;
            // eslint-disable-next-line camelcase
            this.model.evaluation_administrator_model_version =
                response.data.evaluation_administrator_model_version;
            // eslint-disable-next-line camelcase
            this.model.evaluation_gold = response.data.evaluation_gold;
            // eslint-disable-next-line camelcase
            this.model.evaluation_silver = response.data.evaluation_silver;
            // eslint-disable-next-line camelcase
            this.model.evaluation_bronze = response.data.evaluation_bronze;
            })
        this.$emit('update:loading', false)
    },

    saveEvaluation() {
      if (this.validateForm()) {
        const data = this.model;
        let method = "";
        if (this.id) {
          const where = { id: this.id };
          method = "/update?where=" + JSON.stringify(where);
        }
        if (this.clone) {
          method = "/cloneModel/" + this.id;
        }
        axiosCall({ url: "EvaluationModels" + method, method: "POST", data })
          .then(() => {
            this.success = true;
            this.$emit('reload')
          })
          .catch(() => {
          });
      }
    },
  },
};
</script>
